module.exports = __webpack_public_path__ + "bz.c6b9ed7b.svg";